<agr-page-detail [pageTitle]="'add-cycle' | translate" (backAction)="back()">
  <app-cycle-navigation></app-cycle-navigation>
  <div class="cycle-item__container">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</agr-page-detail>
